import { render, staticRenderFns } from "./SocialsLinks.vue?vue&type=template&id=4d524188&lang=pug&"
import script from "./SocialsLinks.vue?vue&type=script&lang=js&"
export * from "./SocialsLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports